import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton } from 'core/components';

function PatientAddModalTemplate({ patientAddModalViewStore, t}) {
    const {
        form,
        patientStore,
        subCategoryStore,
        referenceStore,
        modalParams
    } = patientAddModalViewStore;

    return (
        <section>
                <h3 className='u-mar--bottom--sml'>Add Existing Patient</h3>
                <div className="row">
                    <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                        <BaasicFieldDropdown field={form.$('patientId')} store={patientStore} />
                        <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} />
                        <BaasicFieldDropdown field={form.$('referenceId')} store={referenceStore} />
                    </div>
                    <div className='col col-lrg-12'>
                        <BaasicFormControls
                            form={form} 
                            onSubmit={form.onSubmit} 
                            disabled={form.submitting || form.validating} 
                            label="Save"
                        />  
                        <BaasicButton
                            className='btn btn--base btn--ghost'
                            label={t('EDIT_FORM_LAYOUT.CANCEL')}
                            onClick={() => modalParams.close()}
                        />
                     </div>
                </div>         
        </section> 
    )
}
 
PatientAddModalTemplate.propTypes = {
    patientAddModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientAddModalTemplate);
